import LegalBanner from "@/components/Legal/LegalBanner";
import LegalPageContent from "@/components/Legal/LegalPageContent";
import SEO from "@/components/SEO";
import Collection from "@sourceflow-uk/sourceflow-sdk/collection";
import localizePath from "@/functions/localizePath";

export default function PrivacyPolicyPage({ locale = "en", page }) {
  return (
    <>
      <SEO
        path={localizePath("/privacy-policy", locale)}
        title="Privacy Policy | Lawrence Harvey"
        description="Our Privacy Policy"
      />
      <main className="bg-white md:pt-[10px] sm:min-h-screen">
        <LegalBanner />
        <LegalPageContent data={page} />
      </main>
    </>
  );
}

export async function getStaticProps() {
  const pages = (await Collection("legal_pages")).getItems();
  const page = pages.find((p) => p?.url_slug === "privacy-policy");

  return { props: { page } };
}
